/**
 * Relay for Log In/Sign Up
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const LoginPageQuery = graphql`
  query login_Query {
    viewer {
      ...login_viewer
    }
  }
`;

export const LoginFormFragment = graphql`
  fragment login_viewer on Viewer {
    id
    authentication_info{
      user_pool_id
      client_id
      cognito_domain_url
    }
    profile {
      ...profile @relay(mask: false)
    }
  }
`;

export const LoginFormMutation = graphql`
  mutation login_Mutation($input: LoginInput!) {
    login(input: $input) {
      profile {
        ...profile @relay(mask: false)
      }
      cart {
        id
        license_line_items {
          id
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/login.ts